module.exports = __webpack_public_path__ + "static/media/3.29c1e5e7.png";